// extracted by mini-css-extract-plugin
export default {"checkbox__text":"CheckboxRow_checkbox__text__RShDp"};